
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import {defineComponent, PropType} from "vue";
import {TradeContractFormatGroup} from "@/store/modules/hcs/tradeContractFormatGroup/model";

export default defineComponent({
  name: "TradeContractFormatGroupForm",
  components: {TextFieldLike},
  props: {
    value: {
      type: Object as PropType<TradeContractFormatGroup>,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    hideTitle: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
      'input'
  ],
  data() {
    return {
      data: {
        id: '',
        name: '',
        description: '',
      } as TradeContractFormatGroup,
    }
  },
  methods: {
    handleInput() {
      this.$emit('input', this.data);
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(value: TradeContractFormatGroup) {
        this.data = value;
      }
    }
  }
});
